import { baseInstance } from './baseInstance';

export const getBrandsAPI = (data = {}) => baseInstance.post('/Product/GetHomeManufacture', data);

export const getBrandProducts = (data = {}) => baseInstance.post(`/Product/GetProducts`, data);
